'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _pullout = require('../../pullout');

var _pullout2 = _interopRequireDefault(_pullout);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _breakpoints = require('../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _default = require('../props/default');

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();
var ORGANISM_NAME = 'product-features';

var ProductFeatures = function (_Pullout) {
  _inherits(ProductFeatures, _Pullout);

  function ProductFeatures(props) {
    _classCallCheck(this, ProductFeatures);

    var _this = _possibleConstructorReturn(this, (ProductFeatures.__proto__ || Object.getPrototypeOf(ProductFeatures)).call(this, props));

    _this.state = {
      selectedFeature: 0,
      isDesktop: false
    };

    _this.handleResize = _this.handleResize.bind(_this);
    return _this;
  }

  _createClass(ProductFeatures, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      var newWindowWidth = this.organismRef.ownerDocument.defaultView.innerWidth || this.organismRef.ownerDocument.documentElement.clientWidth || this.organismRef.ownerDocument.body.clientWidth;

      if (newWindowWidth >= _breakpoints2.default.medium) {
        if (!this.state.isDesktop) {
          this.setState({
            isDesktop: true
          });
        }
      } else if (this.state.isDesktop) {
        this.setState({
          isDesktop: false
        });
      }
    }
  }, {
    key: 'handleHover',
    value: function handleHover(tileID) {
      var _this2 = this;

      return function () {
        _this2.setState({
          selectedFeature: tileID
        });
      };
    }
  }, {
    key: 'renderFeatureTile',
    value: function renderFeatureTile(tile, sequence, type, tileSize, tilePosition, selectedFeature, isDesktop) {
      return _react2.default.createElement(
        'div',
        { onMouseEnter: isDesktop && type === 'dynamic' && this.handleHover(sequence), className: ORGANISM_NAME + '__feature-tile ' + tilePosition + ' ' + tileSize + ' ' + type + ' ' + (selectedFeature === sequence ? 'active' : '') },
        _react2.default.createElement('img', { src: tile.content.iconImage.src, alt: tile.content.iconImage.alt }),
        _react2.default.createElement(
          _heading2.default,
          { level: 3 },
          tile.content.headline.text
        ),
        _react2.default.createElement(
          'p',
          null,
          htmlToReactParser.parse(tile.content.paragraph.text)
        )
      );
    }
  }, {
    key: 'renderFeatures',
    value: function renderFeatures(features, type, tileSize) {
      var centerImage = features.centerImage,
          tiles = features.tiles;
      var _state = this.state,
          selectedFeature = _state.selectedFeature,
          isDesktop = _state.isDesktop;


      return _react2.default.createElement(
        'div',
        { className: ORGANISM_NAME + '__features-container row panels__container' },
        _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__features-col col-md-4 ' + type },
          this.renderFeatureTile(tiles[0], 0, type, tileSize, 'left', selectedFeature, isDesktop),
          this.renderFeatureTile(tiles[1], 1, type, tileSize, 'left', selectedFeature, isDesktop)
        ),
        _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__product-image col-md-4' },
          isDesktop && type === 'dynamic' ? _react2.default.createElement('img', { src: tiles[selectedFeature].centerImage.src, alt: tiles[selectedFeature].centerImage.alt }) : _react2.default.createElement('img', { src: centerImage.src, alt: centerImage.alt })
        ),
        _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__features-col col-md-4 ' + type },
          this.renderFeatureTile(tiles[2], 2, type, tileSize, 'right', selectedFeature, isDesktop),
          this.renderFeatureTile(tiles[3], 3, type, tileSize, 'right', selectedFeature, isDesktop)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className;
      var headline = content.headline,
          paragraph = content.paragraph,
          cta = content.cta,
          mediaButton = content.mediaButton,
          hatchText = content.hatchText,
          features = content.features;
      var type = config.type,
          tileSize = config.tileSize,
          theme = config.theme;


      if (!type) {
        type = 'static';
      }
      if (!tileSize) {
        tileSize = 'normal';
      }
      if (!theme) {
        theme = 'theme-background-color-white';
      }

      var pulloutClasses = (0, _classnames2.default)('' + ORGANISM_NAME, className, theme);

      return _react2.default.createElement(
        'section',
        {
          className: pulloutClasses,
          id: config.id,
          'data-building-block': 'organism',
          ref: function ref(c) {
            _this3.organismRef = c;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-12 center-block text-xs-center' },
              this.renderHeadline(headline),
              this.renderContent(paragraph),
              this.renderFeatures(features, type, tileSize),
              this.renderCTA(cta),
              this.renderMediaButton(mediaButton),
              this.renderHatchContent(hatchText)
            )
          )
        )
      );
    }
  }]);

  return ProductFeatures;
}(_pullout2.default);

exports.default = ProductFeatures;


ProductFeatures.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light']),
    type: _propTypes2.default.oneOf(['static', 'dynamic']),
    tileSize: _propTypes2.default.oneOf(['normal', 'large'])
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    features: _propTypes2.default.shape({
      centerImage: _propTypes2.default.shape({
        url: _propTypes2.default.string.isRequired,
        alt: _propTypes2.default.string.isRequired
      }).isRequired,
      tiles: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        centerImage: _propTypes2.default.shape({
          url: _propTypes2.default.string.isRequired,
          alt: _propTypes2.default.string.isRequired
        }),
        content: _propTypes2.default.shape({
          iconImage: _propTypes2.default.shape({
            src: _propTypes2.default.string.isRequired,
            alt: _propTypes2.default.string.isRequired
          }),
          headline: _propTypes2.default.shape({
            text: _propTypes2.default.string.isRequired
          }),
          paragraph: _propTypes2.default.shape({
            text: _propTypes2.default.string.isRequired
          })
        }).isRequired
      }))
    }).isRequired,
    cta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string,
      text: _propTypes2.default.string,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }),
    mediaButton: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      text: _propTypes2.default.string.isRequired,
      'data-video-id': _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    })
  }),
  className: _propTypes2.default.string
};

ProductFeatures.defaultProps = _default2.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/product-features/jsx/ProductFeatures.js
// module id = 1131
// module chunks = 4